import { useQuery } from 'react-query';

import { toOptionsCurry } from 'utils/toOptions';

import { getImportDefinitions } from 'RestAPIs/admin';

export const useGetDefinitionsOptions = () =>
  useQuery({
    queryKey: ['importDefinitions'],
    queryFn: getImportDefinitions,
    select: toOptionsCurry('definitionId', 'description')
  });
